import { createAsyncThunk } from "@reduxjs/toolkit";
import { AddUserState, addUserProps } from "./types";
import axios from "axios";

export const createUser = createAsyncThunk('user/list/add-user', async (props: addUserProps) => {
    const config = {
        headers:{
            api_key: 'Basic 15cb7ebf9-3dcc-h28s-b056-2522c1eed03e',
            token: props.access_token
        }
      };
      const data = {
        first_name: props.first_name,
        last_name: props.last_name,
        email: props.email,
        role_id: props.role_id,
      };
    try {
        const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/merchant/users/add`,
                data,
                config
            );
        if (response && response.data) {
            return {
                data: response.data,
                status: "success",
                error: null
            } as unknown as AddUserState;
        } else {
            return {
                data: response.data?.message,
                status: "empty",
                error: null
            } as unknown as AddUserState;
        }
    } catch (err) {
        if (err)
            return {
                data: 'Something went wrong!',
                status: "error",
                error: err
            } as unknown as AddUserState;

    }
})